import {useContext, useState} from "react";
import FinCheckContext from "../../tools/contexts/finCheck/FincheckContext";
import ListItem from "../ListItem";
import Button from "../Button";
import {Reoverlay} from "reoverlay";
import PolicyModal from "../modals/PolicyModal";

const CreatePayment = () => {
    const finCheckContext = useContext(FinCheckContext);
    const initialPrice = finCheckContext.process.payment.info.init_amount;
    const taxPercent = 10;
    const totalAmount = initialPrice + (initialPrice * taxPercent / 100);
    const [acceptPolicy, setAcceptPolicy] = useState(false);
    const handlePolicyModal = () => {
        Reoverlay.showModal(PolicyModal)
    }
    const handleAcceptPolicy = (e) => {
        setAcceptPolicy(e.target.checked)
    }
    const handleCreatePayment = () => {
        finCheckContext.handleCreatePayment();
    }

    return (<div className="grid grid-cols-1  rounded-lg p-5   bg-white">
        <div className="flex flex-col justify-center items-center">
            <h1 className="my-2 font-bold text-xl">
                پرداخت
            </h1>
            <p className="text-sm mb-2 mt-1 ">برای ادامه فرایند باید پرداخت را انجام دهید.</p>
        </div>
        <ListItem className="w-full" title="مبلغ" isPrice={true} priceUnit="تومان" value={initialPrice / 10}/>
        <ListItem className="w-full" title="مالیات" value={taxPercent} isPercent={true}/>
        <ListItem className="w-full" title="مبلغ پرداختی" isGreen={true} value={totalAmount / 10} priceUnit="تومان"
                  isPrice={true}/>
        <div className="flex justify-between mt-3 py-3 items-center  border-t">
            <div className="flex justify-start    items-center ">
                <span className="text-xs">قوانین را می‌پذیرم</span>
                <input className="mx-2" onChange={handleAcceptPolicy} type="checkbox" checked={acceptPolicy}/>
            </div>
            <span onClick={handlePolicyModal} className="text-blue-400 text-xs underline ">مطالعه قوانین</span>
        </div>
        <div className="mt-2  w-full">
            <Button disabled={!acceptPolicy} theme="green" className="text-sm w-full" rounded="rounded-lg" onClick={handleCreatePayment}>پرداخت</Button>
        </div>
    </div>)
}
export default CreatePayment;